export const config = {
  API_KEY: '27866cf7284947dc9da73d648022a82b',
  HEADER_RAPID_API_KEY: 'eb91de7796msh287afe5e22c5924p179680jsnd6db985dbe31',
};
